import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import Problem from './Problem';
import Solution from './Solution';
import PodcastFeature from './PodcastFeature';
import About from './About';
import Contact from './Contact';
import SEOComponent from './SEOComponent';

const MainSite = () => {
  const homeSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Rebel Heat",
        "url": "https://www.rebelheat.co.uk",
        "logo": "https://www.rebelheat.co.uk/logo.png",
        "description": "A clip-on boiler sensor that measures your home's real heating performance and proves whether it's ready for a heat pump. Data-driven heat loss surveys and heat pump sizing for UK homes, plus heritage buildings and churches.",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "GB"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "Customer Service",
          "availableLanguage": "English"
        }
      },
      {
        "@type": "Service",
        "serviceType": "Heat Pump Readiness Assessment and Heat Loss Survey",
        "provider": {
          "@type": "Organization",
          "name": "Rebel Heat"
        },
        "areaServed": {
          "@type": "Country",
          "name": "United Kingdom"
        },
        "audience": {
          "@type": "Audience",
          "audienceType": "Homeowners, Heating Installers, Heritage Buildings, Churches"
        },
        "description": "Data-driven heat pump readiness assessments, heat loss surveys and accurate heat pump sizing for UK homes, using a clip-on boiler sensor that measures real heating performance"
      },
      {
        "@type": "WebPage",
        "name": "Rebel Heat | Prove Low-Temperature Heating, Cut Heat Pump Install Costs",
        "description": "A clip-on boiler sensor that proves your home can run at low flow temperatures, so you avoid unnecessary radiator upgrades and oversized heat pumps. Data-driven heat loss surveys and heat pump sizing for UK homes.",
        "url": "https://www.rebelheat.co.uk"
      }
    ]
  };

  return (
    <div className="min-h-screen">
      <SEOComponent
        title="Rebel Heat | Prove Low-Temperature Heating, Cut Heat Pump Install Costs"
        description="A clip-on boiler sensor that proves your home can run at low flow temperatures, so you avoid unnecessary radiator upgrades and oversized heat pumps. Data-driven heat loss surveys and heat pump sizing for UK homes."
        url="https://www.rebelheat.co.uk/"
        image="https://www.rebelheat.co.uk/church.jpeg"
        schema={homeSchema}
      />
      <Navigation />
      <Hero />
      <Problem />
      <Solution />
      <PodcastFeature />
      <About />
      <Contact />
    </div>
  );
};

export default MainSite;